'use client';

import { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import TrustBadges from './TrustBadges';
import SocialLinks from './SocialLinks';
import Icon from '@/components/ui/AppIcon';

export default function LoginInteractive({mockCredebtials , socialPlatforms}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Icon name="ArrowPathIcon" size={32} className="animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Login Card */}
        <div className="bg-card rounded-xl shadow-soft border border-border p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-xl mb-4">
              <Icon name="UserCircleIcon" size={32} className="text-primary" />
            </div>
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Welcome Back
            </h1>
            <p className="text-muted-foreground body-large">
              Sign in to access your account
            </p>
          </div>

          {/* Login Form */}
          <LoginForm />

          {/* Social Links */}
          <SocialLinks platforms={socialPlatforms || []}/>
        </div>

        {/* Trust Badges */}
        <TrustBadges />
      </div>
    </div>
  );
}